import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import {
  Card, CardContent, Typography, Box, CircularProgress
} from '@mui/material';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, Label } from 'recharts';
import CountdownTimer from './CountdownTimer';

const getColorByLatency = (latency, isOnline) => {
  if (!isOnline) return 'red';
  if (latency <= 500) return 'green';
  if (latency <= 1000) return 'orange';
  if (latency <= 2000) return 'orangered';
  return 'red';
};

const ServiceStatusCard = ({ name, url }) => {
  const [isOnline, setIsOnline] = useState(null);
  const [latencies, setLatencies] = useState([]);
  const intervalRef = useRef(null);

  const checkService = async () => {
  const start = performance.now();
  try {
    const response = await axios.get(url);
    const latency = Math.round(performance.now() - start);

    const apiStatus = response.data?.status;

    if (apiStatus === 'online' || apiStatus === 'OK') {
      setIsOnline(true);
      setLatencies(prev => [...prev.slice(-9), {
        time: new Date().toLocaleTimeString('pt-BR', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false
        }),
        latency
      }]);
    } else {
      setIsOnline(false);
      setLatencies(prev => [...prev.slice(-9), {
        time: new Date().toLocaleTimeString('pt-BR', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false
        }),
        latency: 0
      }]);
    }
  } catch (error) {
    // Em caso de erro de rede, timeout, 5xx, etc.
    setIsOnline(false);
    setLatencies(prev => [...prev.slice(-9), {
      time: new Date().toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }),
      latency: 0
    }]);
  }
};

  useEffect(() => {
    checkService(); // primeira checagem
    intervalRef.current = setInterval(checkService, 60 * 1000); // a cada 1 minuto
    return () => clearInterval(intervalRef.current);
  }, [url]);

  const lastLatency = latencies.length > 0 ? latencies[latencies.length - 1].latency : 0;
  const strokeColor = getColorByLatency(lastLatency, isOnline);

  return (
    <Card sx={{
        minWidth: 320,
        minHeight: 280,
        margin: 2,
        backgroundColor: '#2a2a2a',
        color: '#fff',
        paddingBottom: 2
        }}>
        <CardContent sx={{ paddingBottom: '8px' }}>
        <Typography variant="h6">{name}</Typography>
        <Typography variant="body2" sx={{ color: '#ccc' }}>
          Status: {
            isOnline === null
              ? <CircularProgress size={12} />
              : isOnline
                ? 'Online ✅'
                : 'Offline ❌'
          }
        </Typography>

        <CountdownTimer initialSeconds={60} />

        <Box height={200} mt={2}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart
                data={latencies}
                margin={{ top: 5, right: 20, left: 30, bottom: 30 }}
                >
             <XAxis dataKey="time" stroke="#ccc">
            <Label
                value="Horário da Resposta"
                position="bottom"
                dy={5}
                style={{ fill: '#ccc', fontSize: 14 }}
            />
            </XAxis>
            <YAxis
            stroke="#ccc"
            tickFormatter={(value) => (value / 1000).toFixed(1)}
            >
            <Label
                value="Latência (Segundos)"
                angle={-90}
                position="left"
                dx={-5}
                dy={-60}
                style={{ fill: '#ccc', fontSize: 14}}
            />
            </YAxis>

              <Tooltip
            cursor={{ stroke: '#888', strokeWidth: 1 }}
            formatter={(value) => [`${(value / 1000).toFixed(2)}s`, 'Latência']}
            labelFormatter={(label) => `Horário: ${label}`}
            contentStyle={{
                backgroundColor: '#1e1e1e',
                border: '1px solid #555',
                borderRadius: 6,
                color: '#fff'
            }}
            />
              <Line
                type="monotone"
                dataKey="latency"
                stroke={strokeColor}
                strokeWidth={2}
                dot={{ r: 4, stroke: strokeColor }}
              />
            </LineChart>
          </ResponsiveContainer>
        </Box>

      </CardContent>
    </Card>
  );
};

export default ServiceStatusCard;
